/* Puts a preload method on every lazy component */
import { lazy,} from 'react'







const lazyPreload = (thunk) => {
  const lazyComponent = lazy(thunk) 
  lazyComponent.preload = thunk
  return lazyComponent
}

export default lazyPreload
